import { Box, Typography, styled } from "@mui/material";
import { colors, fonts } from "../../../assets/styles/theme.ts";

export const Styled = styled(Box)`
  display:flex;
  align-items: baseline;
 @media screen and (max-width: 768px) {
    gap: 0px;
    padding: 0px;
  }
`

export const DivImg = styled(Box)`
  height: 40px;
  display: flex;
  align-items: baseline;           
  justify-content: flex-end;

  .img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: inherit;
    cursor: pointer;
    display: block;
  }

  &:hover {
    background-color: ${colors.disabled};
  }

  @media screen and (max-width: 768px) {}
`;

export const DivLabel = styled(Box)`
  
`

export const Title = styled(Typography)`
  &&{
    color: ${colors.blueDark};
    font-family: ${fonts.primary};
    font-size: 16px;
    font-weight: 500;
    /* position: absolute;
    right: 60px; */
    text-align: end;
     @media screen and (max-width: 768px) {
    text-align: start;
  }
  }
`

export const DivIconLogout = styled(Box)`
 cursor: pointer;
 display: flex;
`